(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sharp-glove-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sharp-glove-swatches')) {
    customElements.define('sharp-glove-swatches',class extends HTMLElement {
      connectedCallback() {
        if(this.ready) return;
        this.ready=true;
        this.card=this.closest('[data-glove-card]');
        if(!this.card) return;
        this.buttons=[...this.querySelectorAll('[data-glove-color]')];
        this.variants=JSON.parse(this.querySelector('[data-glove-variants]').textContent);
        this.select=this.card.querySelector('[data-gear-variant], [data-glove-size]');
        this.buttons.forEach(button=>button.addEventListener('click',()=>this.choose(button)));
        this.select?.addEventListener('change',()=>this.updateLinks());
        if(this.buttons.length) this.choose(this.buttons[0]);
      }
      choose(button) {
        const previous=this.select?.selectedOptions[0];
        const size=previous?.dataset.size || previous?.value;
        this.color=button.dataset.gloveColor;
        this.buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
        this.querySelector('[data-glove-color-name]').textContent=this.color;
        const image=this.card.querySelector('img');
        if(image && button.dataset.gloveImage) {
          image.removeAttribute('srcset');image.src=button.dataset.gloveImage;
          image.alt=`${this.card.querySelector('h2,h3')?.textContent.trim() || ''} — ${this.color}`;
        }
        if(this.select?.matches('[data-gear-variant]')) {
          const options=[...this.select.options];
          options.forEach(option=>{option.hidden=option.dataset.color!==this.color;});
          const target=options.find(option=>!option.hidden && option.dataset.size===size) || options.find(option=>!option.hidden);
          if(target){this.select.value=target.value;this.select.dispatchEvent(new Event('change',{bubbles:true}));}
        }
        this.updateLinks();
      }
      updateLinks() {
        const selected=this.select?.selectedOptions[0];
        const variant=this.select?.matches('[data-gear-variant]') ? this.variants.find(item=>String(item.id)===this.select.value) : this.variants.find(item=>item.color===this.color && item.size===(selected?.value || 'Small'));
        if(!variant) return;
        const url=`${this.dataset.productUrl}?variant=${variant.id}`;
        this.card.querySelectorAll('a[href*="/products/"]').forEach(link=>link.href=url);
        this.card.querySelectorAll('[data-product-url]').forEach(control=>{if(control!==this)control.dataset.productUrl=url;});
        this.card.querySelectorAll('input[name="id"]').forEach(input=>input.value=variant.id);
        const matching=this.buttons.find(button=>button.dataset.gloveColor===variant.color);
        if(matching && variant.color!==this.color){this.choose(matching);}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sharp-nicholls-bag-card"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sharp-nicholls-bag-card')){
  customElements.define('sharp-nicholls-bag-card',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      const buttons=[...this.querySelectorAll('[data-bag-color]')];
      buttons.forEach(button=>button.addEventListener('click',()=>{
        buttons.forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
        this.querySelector('[data-bag-price]').textContent=button.dataset.bagPrice;
        this.querySelector('[data-bag-stock]').hidden=button.dataset.bagAvailable==='true';
        const image=this.querySelector('.stg__image img');
        if(image){image.removeAttribute('srcset');image.src=button.dataset.bagImage;image.alt=button.dataset.bagTitle;}
        const photoLink=this.querySelector('.stg__image');
        const hoverImage=this.querySelector('.nicholls-bag-hover-image');
        photoLink.classList.toggle('has-nicholls-bag-hover',Boolean(button.dataset.bagHoverUrl));
        if(hoverImage&&button.dataset.bagHoverUrl){hoverImage.removeAttribute('srcset');hoverImage.src=button.dataset.bagHoverUrl;}
        this.querySelectorAll('[data-bag-link]').forEach(link=>{
          link.href=button.dataset.bagUrl;
          if(link.matches('.stg__image'))link.setAttribute('aria-label',button.dataset.bagTitle);
        });
      }));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sharp-order-window"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sharp-order-window')) {
    class SharpOrderWindow extends HTMLElement {
      connectedCallback() {
        this.heading = this.querySelector('[data-window-heading]');
        if (!this.heading) return;
        this.description = this.querySelector('[data-window-description]');
        this.deadline = this.querySelector('[data-window-deadline]');
        this.timer = this.querySelector('[data-window-timer]');
        this.status = this.querySelector('[data-window-status]');
        this.announcement = this.querySelector('[data-window-announcement]');
        this.demo = 'configured';
        this.onVisible = () => this.update();
        this.onPreview = event => { this.demo = event.detail; this.demoStart = Date.now(); this.update(); };
        this.addEventListener('sharp:window-preview', this.onPreview);
        document.addEventListener('visibilitychange', this.onVisible);
        this.update();
        this.interval = setInterval(() => this.update(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.onVisible);
        this.removeEventListener('sharp:window-preview', this.onPreview);
      }
      parseInstant(value) {
        const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
        if (!match) return NaN;
        const [,y,m,d,h,min,s,zone] = match;
        const days = new Date(Date.UTC(Number(y),Number(m),0)).getUTCDate();
        if (+m<1 || +m>12 || +d<1 || +d>days || +h>23 || +min>59 || +s>59) return NaN;
        if (zone !== 'Z' && (+zone.slice(1,3)>14 || +zone.slice(4)>59 || (+zone.slice(1,3)===14 && +zone.slice(4)!==0))) return NaN;
        return Date.parse(value);
      }
      resolveState(open, close, now, paused, stage, threshold) {
        if (!Number.isFinite(open) || !Number.isFinite(close) || close<=open) return 'unconfirmed';
        if (paused) return 'paused';
        if (now<open) return 'upcoming';
        if (now<close) return close-now<=threshold ? 'closing' : 'open';
        return ['production','fulfillment','complete'].includes(stage) ? stage : 'closed';
      }
      text(kind,key) { return this.querySelector(`[data-${kind}="${key}"]`)?.textContent || ''; }
      update() {
        let open = this.parseInstant(this.dataset.open);
        let close = this.parseInstant(this.dataset.close);
        let now = Date.now();
        let paused = this.dataset.paused === 'true';
        let stage = this.dataset.stage;
        const threshold = Math.max(0,Number(this.dataset.closingHours)||0)*3600000;
        if (this.demo !== 'configured') {
          open = this.demoStart-86400000;
          close = this.demoStart+4*86400000+14*3600000+22*60000;
          paused = false; stage = 'closed';
          if (this.demo==='upcoming') open=this.demoStart+2*86400000;
          if (this.demo==='closing') close=this.demoStart+2*3600000+22*60000;
          if (this.demo==='zero') close=this.demoStart+10000;
          if (['closed','production','fulfillment','complete'].includes(this.demo)) { close=this.demoStart-3600000; stage=this.demo; }
          if (this.demo==='paused') paused=true;
          if (this.demo==='unconfirmed') close=NaN;
        }
        let formatter;
        let state = this.resolveState(open,close,now,paused,stage,threshold);
        try { formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {timeZone:this.dataset.timezone,month:'short',day:'numeric',year:'numeric',hour:'numeric',minute:'2-digit',timeZoneName:'short'}); }
        catch { state='unconfirmed'; }
        const title = this.text('state-title',state);
        this.heading.textContent=title;
        this.description.textContent=this.text('state-message',state);
        this.deadline.textContent='';
        if (state!=='unconfirmed') {
          const key=state==='upcoming'?'opens':now>=close?'closed':'closes';
          this.deadline.textContent=`${this.text('label',key)} ${formatter.format(new Date(key==='opens'?open:close))}`;
        }
        const counting=['upcoming','open','closing'].includes(state);
        this.timer.hidden=!counting;
        this.status.hidden=counting;
        this.status.textContent=title;
        if (counting) {
          const remaining=Math.max(0,(state==='upcoming'?open:close)-now);
          const minutes=Math.ceil(remaining/60000);
          this.querySelector('[data-window-days]').textContent=String(Math.floor(minutes/1440)).padStart(2,'0');
          this.querySelector('[data-window-hours]').textContent=String(Math.floor(minutes/60)%24).padStart(2,'0');
          this.querySelector('[data-window-minutes]').textContent=String(minutes%60).padStart(2,'0');
          if (remaining<60000) this.description.textContent=this.text('label','less_than_minute');
        }
        if (this.dataset.state!==state) {
          this.dataset.state=state;
          this.announcement.textContent=title;
          this.dispatchEvent(new CustomEvent('sharp:window-state',{bubbles:true,detail:{state}}));
        }
      }
    }
    customElements.define('sharp-order-window',SharpOrderWindow);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sharp-patterson-showroom"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-phs-shop]').forEach(shop=>{
  if(shop.dataset.ready)return;
  shop.dataset.ready='true';
  const items=[...shop.querySelector('[data-phs-grid]').children];
  const params=new URLSearchParams(location.search);
  let audience=['men','women','youth','player'].includes(params.get('audience'))?params.get('audience'):'all';
  let category=['tops','bottoms','accessories','players_pack'].includes((params.get('category')||'').replace('players-pack','players_pack'))?params.get('category').replace('players-pack','players_pack'):'all';
  if(audience!=='player'&&category==='players_pack')category='all';
  let style='all';
  const isBag=item=>item.hasAttribute('data-nicholls-shared-bag');
  const isGlove=item=>item.hasAttribute('data-glove-card');
  const isMitt=item=>item.hasAttribute('data-mitt-card');
  const isPack=item=>item.hasAttribute('data-phs-pack-item');
  const isYouthGlove=item=>isGlove(item)&&(item.dataset.gearHandle||'').endsWith('-youth');
  const matchesAudience=item=>isBag(item)||audience==='all'||(isPack(item)&&audience==='player')||(isGlove(item)?(audience==='player'||(audience==='youth'?isYouthGlove(item):audience==='men'&&!isYouthGlove(item))):(audience==='player'?item.dataset.player==='true':(item.dataset.audiences||'').split(' ').includes(audience)));
  const merchandiseRank=item=>{
    const key=(item.querySelector('h3')?.textContent||'').toLowerCase()+' '+(item.querySelector('a[href*="/products/"]')?.getAttribute('href')||'').toLowerCase();
    if(isBag(item))return 7;
    if(isGlove(item)||item.dataset.category==='accessories')return 8;
    if(/quarter[ -]zip|cage/.test(key))return 2;
    if(/polo/.test(key))return 1;
    if(/hoodie|hooded/.test(key))return 3;
    if(/track/.test(key))return /pant/.test(key)?4.1:4;
    if(item.dataset.category==='bottoms')return 6;
    if(/tee|t-shirt|tank/.test(key))return 0;
    return 5;
  };
  const matchesCategory=(item,key)=>key==='players_pack'?isPack(item):!isPack(item)&&(key==='all'||(isBag(item)||isGlove(item)?key==='accessories':item.dataset.category===key));
  const update=()=>{
    let visible=0;
    shop.querySelector('[data-phs-required]').hidden=category!=='players_pack';
    items.forEach((item,index)=>{
      item.hidden=!(matchesAudience(item)&&matchesCategory(item,category)&&(style==='all'||item.dataset.style===style));
      if(!item.hidden)visible++;
      item.style.order=String(category==='players_pack'?(isPack(item)?Number(item.dataset.packOrder):100+index):(isYouthGlove(item)&&audience==='all'?100000:0)+merchandiseRank(item)*1000+index);
      if(!isBag(item)&&!isPack(item)&&!isGlove(item)&&!isMitt(item))item.querySelectorAll('a[href*="/products/"]').forEach(link=>{
        const url=new URL(link.href,location.origin);
        const variants=JSON.parse(item.querySelector('[data-phs-variants]')?.textContent||'[]');
        const color=item.querySelector('[data-sharp-card-color-swatch][aria-pressed="true"]')?.dataset.sharpCardColor;
        const needsYouth=audience==='youth';
        const matches=variants.filter(v=>v.options.some(o=>/youth/i.test(o))===needsYouth&&(!color||v.options.includes(color)));
        const selected=matches.find(v=>v.available)||matches[0];
        if(selected)url.searchParams.set('variant',String(selected.id));
        url.searchParams.delete('age');
        link.href=url.pathname+url.search;
        if(link.hasAttribute('data-product-url'))link.dataset.productUrl=link.href;
      });
    });
    shop.querySelectorAll('[data-phs-audience]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.phsAudience===audience)));
    shop.querySelectorAll('[data-phs-category]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.phsCategory===category));b.hidden=b.dataset.phsCategory==='players_pack'?audience!=='player':b.dataset.phsCategory!=='all'&&!items.some(item=>matchesAudience(item)&&matchesCategory(item,b.dataset.phsCategory));});
    shop.querySelector('.phs-shop__styles').hidden=category!=='tops';
    shop.querySelectorAll('[data-phs-style]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.phsStyle===style));b.hidden=b.dataset.phsStyle!=='all'&&!items.some(item=>matchesAudience(item)&&item.dataset.category==='tops'&&item.dataset.style===b.dataset.phsStyle);});
    shop.querySelector('[data-phs-empty]').hidden=visible>0;
    shop.querySelector('[data-phs-status]').textContent=String(visible);
    const url=new URL(location.href);url.searchParams.set('audience',audience);url.searchParams.set('category',category);history.replaceState(history.state,'',url);
  };
  shop.querySelectorAll('[data-phs-audience]').forEach(b=>b.addEventListener('click',()=>{audience=b.dataset.phsAudience;category=audience==='player'?'players_pack':'all';style='all';update();}));
  shop.querySelectorAll('[data-phs-category]').forEach(b=>b.addEventListener('click',()=>{category=b.dataset.phsCategory;style='all';update();}));
  shop.querySelectorAll('[data-phs-style]').forEach(b=>b.addEventListener('click',()=>{style=b.dataset.phsStyle;update();}));
  shop.addEventListener('click',event=>{if(event.target.closest('[data-sharp-card-color-swatch]'))queueMicrotask(update);});
  update();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sharp-shared-gear-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sharp-team-gear-card')) {
    customElements.define('sharp-team-gear-card',class extends HTMLElement {
      connectedCallback() {
        if(this.initialized) return;
        this.initialized=true;
        this.querySelectorAll('form').forEach(form => {
          const select = form.querySelector('[data-gear-variant]');
          const button = form.querySelector('[type=submit]');
          const status = form.querySelector('[data-gear-status]');
          select.addEventListener('change', () => {
            const option = select.selectedOptions[0];
            button.disabled = option.dataset.available !== 'true';
            button.textContent = button.disabled ? this.dataset.soldOut : this.dataset.add;
            form.closest('[data-gear-card]').querySelector('[data-gear-price]').textContent = option.dataset.price;
            const image = form.closest('[data-gear-card]').querySelector('img');
            if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
            const photoLink = this.querySelector('[data-gear-photo-link]');
            if (photoLink) { const target = new URL(photoLink.href); target.searchParams.set('variant', select.value); photoLink.href = target.href; }
            status.textContent = '';
          });
          form.addEventListener('submit', async event => {
            event.preventDefault();
            if (button.disabled) return;
            button.disabled = true;
            button.setAttribute('aria-busy','true');
            status.textContent = '';
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            const data = new FormData(form);
            const sections = cart?.getSectionsToRender?.().map(section => section.id) || ['cart-icon-bubble'];
            data.append('sections', sections.join(','));
            data.append('sections_url', window.location.pathname);
            cart?.setActiveElement?.(button);
            try {
              const root = window.Shopify?.routes?.root || '/';
              const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},body:data});
              const result = await response.json();
              if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
              status.textContent = this.dataset.added;
              if (cart?.renderContents) {
                try { cart.renderContents(result); } catch (renderError) {}
              }
              else if (result.sections?.['cart-icon-bubble']) {
                const parsed = new DOMParser().parseFromString(result.sections['cart-icon-bubble'],'text/html');
                const bubble = document.getElementById('cart-icon-bubble');
                const nextBubble = parsed.getElementById('cart-icon-bubble');
                if (bubble && nextBubble) bubble.innerHTML = nextBubble.innerHTML;
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'shared-team-gear',productVariantId:select.value,cartData:result});
            } catch (error) { status.textContent = error.message || this.dataset.error; }
            finally { button.disabled = select.selectedOptions[0].dataset.available !== 'true'; button.removeAttribute('aria-busy'); }
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sharp-team-accessory-colors"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sharp-team-accessory-colors')){
 customElements.define('sharp-team-accessory-colors',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const init=()=>{
    this.card=this.closest('[data-gear-card]');if(!this.card)return;
    this.buttons=[...this.querySelectorAll('[data-accessory-color]')];
    this.buttons.forEach(button=>button.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();this.choose(button);}));
    if(this.buttons[0])this.choose(this.buttons[0]);
   };
   if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  }
  choose(button){
   this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   this.querySelector('[data-accessory-name]').textContent=button.dataset.accessoryColor;
   const img=this.card.querySelector('.stg__image img');
   if(img&&button.dataset.image){img.removeAttribute('srcset');img.src=button.dataset.image;img.alt=this.card.querySelector('h3').textContent.trim()+' — '+button.dataset.accessoryColor;}
   const target=new URL(this.dataset.url,location.origin);target.searchParams.set('variant',button.dataset.variant);
   this.card.querySelectorAll('a[href*="/products/"]').forEach(a=>{a.href=target.pathname+target.search;});
   const price=this.card.querySelector('[data-gear-price]');if(price)price.textContent=button.dataset.price;
   this.card.dispatchEvent(new CustomEvent('sharp:accessory-color',{bubbles:true,detail:{color:button.dataset.accessoryColor,variant:button.dataset.variant}}));
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sharp-team-return"] && !Shopify.designMode) return;
  try {
    function polishTeamJump(){
 if(!document.querySelector('.sharp-team-return'))return;
 const jump=document.querySelector('.sharp-product-jump');
 if(jump){jump.href='#sharp-team-options';jump.firstChild.textContent='Choose size & color ';}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',polishTeamJump);else polishTeamJump();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sharp-track-options"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const input = event.target.closest('variant-selects input[data-option-name], variant-selects select');
    if (!input) return;
    const name = input.dataset.optionName || input.name.replace(/^options\[/, '').replace(/\]$/, '');
    if (name.toLowerCase() !== 'size') return;
    const track = input.closest('product-info')?.querySelector('[data-sharp-track-options]');
    if (!track) return;
    track.dataset.currentSize = input.value;
    track.querySelectorAll('[data-sharp-track-sizes]').forEach((link) => {
      const variantId = JSON.parse(link.dataset.sharpTrackSizes)[input.value];
      if (!variantId) return;
      link.href = link.dataset.sharpTrackUrl + '?variant=' + variantId;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sharp-ultrafit-grid"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.sharp-ultrafit-card').forEach(card=>{
  card.querySelectorAll('.sharp-ultrafit-card__color').forEach(swatch=>swatch.addEventListener('click',event=>{
    if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    event.preventDefault();
    const image=card.querySelector('.sharp-ultrafit-card__photo img');
    image.removeAttribute('srcset');image.src=swatch.dataset.colorImage;
    card.querySelectorAll('.sharp-ultrafit-card__color').forEach(other=>{other.classList.toggle('is-selected',other===swatch);other.setAttribute('aria-pressed',String(other===swatch));});
    card.querySelector('.sharp-ultrafit-card__selected strong').textContent=swatch.dataset.colorName;
    card.querySelector('.sharp-ultrafit-card__heading p').textContent=swatch.dataset.colorPrice;
    card.querySelectorAll('.sharp-ultrafit-card__photo,.sharp-ultrafit-card__heading a,.sharp-ultrafit-card__shop').forEach(link=>link.href=swatch.dataset.colorUrl);
    card.querySelector('.sharp-ultrafit-card__photo').setAttribute('aria-label',card.querySelector('h2').textContent+' — '+swatch.dataset.colorName);
  }));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sharp-youth-shop"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-youth-shop]').forEach(shop=>{
  const cards=[...shop.querySelectorAll('[data-youth-group]')];
  const primary=[...shop.querySelectorAll('.sharp-youth-nav button')];
  const secondary=[...shop.querySelectorAll('.sharp-youth-families button')];
  const groupRank={tops:0,bottoms:1,accessories:2};
  const familyRank={tees:0,compression:1,outdoor:2,jackets:3,accessories:4,bags:5};
  const labels=new Map(secondary.map(b=>[b,b.textContent]));
  const browser=shop.querySelector('.sharp-youth-browser');
  const path=shop.querySelector('[data-youth-path]');
  const count=shop.querySelector('[data-youth-count]');
  let group='all',family='all';
  cards.sort((a,b)=>(groupRank[a.dataset.youthGroup]-groupRank[b.dataset.youthGroup])||(familyRank[a.dataset.youthFamily]-familyRank[b.dataset.youthFamily])||a.textContent.localeCompare(b.textContent)).forEach(card=>shop.querySelector('.sharp-youth-products').append(card));
  function update(){
    primary.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.youthFilter===group)));
    secondary.forEach(b=>{
      const key=b.dataset.youthFilter;
      b.hidden=key!=='all'&&!cards.some(c=>(group==='all'||c.dataset.youthGroup===group)&&c.dataset.youthFamily===key);
      b.textContent=key==='all'?'All '+(group==='all'?'Kids':group.charAt(0).toUpperCase()+group.slice(1)):key==='jackets'&&group==='bottoms'?'Track pants':labels.get(b);
      b.setAttribute('aria-pressed',String(key===family));
    });
    cards.forEach(c=>c.hidden=!((group==='all'||c.dataset.youthGroup===group)&&(family==='all'||c.dataset.youthFamily===family)));
    const selected=secondary.find(b=>b.dataset.youthFilter===family);
    path.textContent=selected?.textContent||'All Kids';
    count.textContent=cards.filter(c=>!c.hidden).length+' products';
    const key=group==='bottoms'?'bottoms':family==='all'?group:family;
    const hero=shop.closest('.sharp-category-landing')?.querySelector('.sharp-audience-hero__image');
    const image=shop.querySelector('[data-youth-hero="'+key+'"]');
    if(hero&&image){hero.removeAttribute('srcset');hero.src=image.dataset.src;hero.alt=image.dataset.alt;hero.style.objectPosition=image.dataset.position||'50% 50%';}
  }
  primary.forEach(b=>b.addEventListener('click',()=>{group=b.dataset.youthFilter;family='all';update();browser.open=false;}));
  secondary.forEach(b=>b.addEventListener('click',()=>{family=b.dataset.youthFilter;update();browser.open=false;browser.querySelector('summary').focus({preventScroll:true});}));
  update();
});
  } catch(e) { console.error(e); }
})();

})();
